export enum LegalType {
  COMPANY = "company",
  INDIVIDUAL = "individual",
  UNDEFINED = "undefined",
}

export const getLegalTypeName = (type: LegalType): string => {
  if (LegalType.INDIVIDUAL === type) {
    return "Sending Money to an Individual";
  }

  return "Sending Money to a Business";
};
